import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ParagraphTextService } from '../paragraph-text-service';
import _ from 'lodash';

@injectable()
export class ParagraphTextServiceImpl<T> implements ParagraphTextService<T> {

    private _text: string = '';

    private _type: T;

    getParagraphText(): string {
        return this._text;
    }

    updateParagraphText(text: string) {
        this._text = text;
    }

    getParagraphTextType(): T {
        return this._type;
    }

    updateParagraphTextType(type: T) {
        this._type = type;
    }
}
